import axios from "axios";
import QS from "qs";
import xlooLib from "../../../librarys/xlooLib";


export default {
    SET_loginDonor: async (context, payload) => {
        const urlDonorPortal = context.rootGetters["settingsAndCustomize/configurationSite"].urlSite;

        const typeLogin = context.rootGetters["settingsAndCustomize/donorPortalSettings"].dhq.enable?'dhq':'standard';
        const urlRequest = urlDonorPortal + 'api'
        let dataRequest

        switch (typeLogin){

            case 'dhq':
                dataRequest = {
                    action: 'loginDonor',
                    dhqLocation: context.rootGetters["settingsAndCustomize/donorPortalSettings"].dhq.location,
                    dhqRestUrl: context.rootGetters["settingsAndCustomize/donorPortalSettings"].dhq.restUrl,
                    login: payload.login,
                    passwordMd5: payload.passwordMd5,
                    typeLogin: typeLogin,
                }
                break

            case "standard":
                dataRequest = {
                    action: 'loginDonor',
                    login: payload.login,
                    passwordMd5: payload.passwordMd5,
                    typeLogin: typeLogin,
                }
                break
        }
        try {
            const res_loginDonor = await axios.post(urlRequest, QS.stringify(dataRequest));
            // const res_loginDonor = testData
            if (res_loginDonor.data.status === 'ok') {
                xlooLib.setCookie('auth', true, 0)
                const csrfToken = res_loginDonor.data.data.csrf_token ? res_loginDonor.data.data.csrf_token : ''

                context.commit('set_csrfToken', csrfToken)
                await context.dispatch('SET_writeDataLogin', res_loginDonor.data.data)
            } else {
                context.commit('set_authDonor', false)
            }
            return res_loginDonor.data
        } catch (e) {
            context.commit('setError', e, {root: true});
            throw e
        }
    },
    SET_logout: async ( context, payload )=>{
        console.log ('LOGOUT payload ->', payload)

        context.commit('set_authDonor', false)
        const urlRequest = context.rootGetters["settingsAndCustomize/configurationSite"].urlSite + 'api'
        const dataRequest = {
            action: 'logoutDonor',
        }
        try {
            await axios.post(urlRequest, QS.stringify(dataRequest));
            xlooLib.cleanAllLocalStorages()
            xlooLib.cleanCookie('auth')
            context.commit('set_authDonor', false)
            context.commit('set_csrfToken', '')
            switch (payload){
                case 'standard':
                    location.reload()
                    break
                case 'sessionExpires':
                    location.href = location.origin +
                        context.rootGetters["settingsAndCustomize/configurationSite"].urlSubdomain +
                        'login-donor?reloadPath=' +
                        location.pathname.replace('/donorportal', '')
                    break
            }
        } catch (e) {
            context.commit('setError', e, {root: true});
            throw e
        }
    },
    // eslint-disable-next-line no-unused-vars
    SET_restartLoginDonor: async (context) => {
        const urlRequest = context.rootGetters["settingsAndCustomize/configurationSite"].urlSite + 'api';
        const dataRequest = {
            action: 'restartLoginDonor',
        }
        try {
            const res_reLoginDonor = await axios.post(urlRequest, QS.stringify(dataRequest));
            if (res_reLoginDonor.data.status === 'ok') {
                if (typeof res_reLoginDonor.data.data.email1 !== 'undefined') {
                    res_reLoginDonor.data.data.email_address = res_reLoginDonor.data.data.email1
                }
                await context.dispatch('SET_writeDataLogin', res_reLoginDonor.data.data)
                xlooLib.setCookie('auth', true, 0)
                const csrfToken = res_reLoginDonor.data.data.csrf_token ? res_reLoginDonor.data.data.csrf_token : ''
                context.commit('set_csrfToken', csrfToken)
            } else {
                context.commit('set_authDonor', false)
                xlooLib.cleanCookie('auth')
            }
        } catch (e) {
            context.commit('setError', e, {root: true});
            throw e
        }
    },
    SET_getPasswordMd5:  async (context) => {
        if (context.rootGetters["donorInformation/idDonor"]==='') return 'no_auth'
        const urlRequest = context.rootGetters["settingsAndCustomize/configurationSite"].urlSite + 'api'
        const dataRequest = {
            action: 'getPasswordMd5',
        }
        try {
            const response = await axios.post(urlRequest, QS.stringify(dataRequest))

            if (typeof response.data.result.entry_list !=='undefined' || response.data.result.entry_list.length>0) {
                return response.data.result.entry_list[0].name_value_list.password_c.value
            }
            return 'not_found'
        } catch (e) {
            context.commit('setError', e, {root: true});
            throw e
        }
    },
    SET_resetDonorPassword: async (context, payload) => {
        const urlRequest = context.rootGetters["settingsAndCustomize/configurationSite"].urlSite + 'api'
        let idDonor
        if (typeof payload.idDonor === 'undefined'){
            idDonor = context.rootGetters["donorInformation/idDonor"]
        } else {
            idDonor = payload.idDonor
        }
        const dataRequest = {
            action: 'resetDonorPassword',
            module_name: 'Donor_Donor',
            id: idDonor,
            password_c: payload.newPassword,
            noThread: 0,
        }
        try {
            // eslint-disable-next-line no-unused-vars
            const response = await axios.post(urlRequest, QS.stringify(dataRequest))
        }  catch (e) {
            context.commit('setError', e, {root: true});
            throw e
        }
    },

    SET_writeDataLogin(context, payload) {
        if (typeof payload.id_c !== 'undefined') {
            context.commit('donorInformation/set_idDonor', payload.id_c, {root: true})
            context.commit('set_authDonor', true)
        }
        if (typeof payload.id !== 'undefined') {
            context.commit('donorInformation/set_idDonor', payload.id, {root: true})
            context.commit('set_authDonor', true)
        }
        const fields = {
            email_address: 'set_email',
            first_name: 'set_firstName',
            bloodtype: 'set_bloodType',
            last_name: 'set_lastName',
            dob: 'set_dob',
            phone_mobile: 'set_phoneMobile',
            phone_home: 'set_phoneHome',
            primary_address_postalcode: 'set_zipCode',
            primary_address_street: 'set_street',
            primary_address_city: 'set_city',
            primary_address_state: 'set_state',
            prohibitingStatuse: 'set_prohibitingStatuse',
            points_total: 'set_pointsTotal',
            sum_rewards_points: 'set_sumRewardsPoints',
            lifetime_donations_wb_c: 'set_lifetimeDonationsWbc',
            lifetime_donations_plt_c: 'set_lifetimeDonationsPlt',
            lifetime_donations_drbc_c: 'set_lifetimeDonationsDrbc',
            lifetime_donations_alyrp_c: 'set_lifetimeDonationsAlyrp',
            lifetime_donations_total_c: 'set_lifetimeDonationsTotal',
            donorid: 'set_donorId',
            sms_opted_out: 'set_smsOptedOut'

        };
        for (let i in fields) {
            if (typeof payload[i] !== 'undefined') {
                context.commit('donorInformation/' + fields[i], payload[i], {root: true})
            }
        }

    },
    SET_updateDhqToken: async (context, payload) => {
        const urlRequest = context.rootGetters["settingsAndCustomize/configurationSite"].urlSite + 'api'
        const dataRequest = {
            action: 'dhqTokenUpdate',
//            hashDonor: context.rootGetters["donorInformation/idDonor"],
            hashDonor: context.rootGetters["donorInformation/email"],
            hash: payload,
            urlLocation: context.rootGetters["settingsAndCustomize/donorPortalSettings"].dhq.location,
        }
        try {
            // eslint-disable-next-line no-unused-vars
            const response = await axios.post(urlRequest, QS.stringify(dataRequest))
        }  catch (e) {
            context.commit('setError', e, {root: true});
            throw e
        }
    },
    SET_checkNewAccount: async (context, payload) => {
        // eslint-disable-next-line no-unused-vars
        const urlRequest = context.rootGetters["settingsAndCustomize/configurationSite"].urlSite + 'api'
        try {
            const checkNewAccount = await axios.post(urlRequest, QS.stringify(payload));
            return checkNewAccount.data
        } catch (e) {
            context.commit('setError', e, {root: true});
            throw e
        }
    },
    SET_activationCodeRequest: async (context, payload) => {
        const urlRequest = context.rootGetters["settingsAndCustomize/configurationSite"].urlSite + 'api'

        payload.action = 'apiPointPortal'
        payload.apiPointAction = 'ActivationCode'
        try {
            const res = await axios.post(urlRequest, QS.stringify(payload));
            console.log('activationCodeRequest res = ', res)
            return res.data
        } catch (e) {
            context.commit('setError', e, {root: true});
            throw e
        }
    },
    SET_forgotPassword: async (context, payload) => {
        console.log('activationCodeRequest payload = ', payload)

        const urlRequest = context.rootGetters["settingsAndCustomize/configurationSite"].urlSite + 'api'

        payload.action = 'apiPointPortal'
        payload.apiPointAction = 'ForgotPassword'
        try {
            const res = await axios.post(urlRequest, QS.stringify(payload));
            console.log('forgot password res = ', res)
            return res.data
        } catch (e) {
            context.commit('setError', e, {root: true});
            throw e
        }
    },
    SET_forgotDonorId: async (context, payload) => {

        const urlRequest = context.rootGetters["settingsAndCustomize/configurationSite"].urlSite + 'api'

        payload.action = 'apiPointPortal'
        payload.apiPointAction = 'ForgotDonorId'
        try {
            const res = await axios.post(urlRequest, QS.stringify(payload));
            return res.data
        } catch (e) {
            context.commit('setError', e, {root: true});
            throw e
        }
    },
    SET_generateDonorCard: async (context) => {
        const urlDonorPortal = context.rootGetters["settingsAndCustomize/configurationSite"].urlSite;
        const urlRequest = urlDonorPortal + 'api'

        await axios.get(urlRequest + '?action=generateDonorCard&id=' + context.rootGetters['donorInformation/idDonor'],
            {
                responseType: 'arraybuffer',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/pdf'
                }
            })
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'donor_card.pdf'); //or any other extension
                document.body.appendChild(link);
                link.click();
            })
            .catch((error) => console.log(error))

    },
}
